export class FSxRestoreDestinationWindowsRestoreOptionsActiveDirectory {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "type",
            "baseName": "type",
            "type": "FsxActiveDirectoryType",
            "format": ""
        },
        {
            "name": "domainJoinServiceAccountSecretArn",
            "baseName": "domainJoinServiceAccountSecretArn",
            "type": "string",
            "format": ""
        },
        {
            "name": "domainName",
            "baseName": "domainName",
            "type": "string",
            "format": ""
        },
        {
            "name": "dnsIps",
            "baseName": "dnsIps",
            "type": "Array<string>",
            "format": "ipv4"
        },
        {
            "name": "organizationalUnitDistinguishedName",
            "baseName": "organizationalUnitDistinguishedName",
            "type": "string",
            "format": ""
        },
        {
            "name": "fileSystemAdministratorsGroup",
            "baseName": "fileSystemAdministratorsGroup",
            "type": "string",
            "format": ""
        },
        {
            "name": "activeDirectoryId",
            "baseName": "activeDirectoryId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return FSxRestoreDestinationWindowsRestoreOptionsActiveDirectory.attributeTypeMap;
    }
    constructor() {
    }
}
